import {
  AddressIcon_default
} from "./chunk-ELRHEXYA.mjs";
export {
  AddressIcon_default as default
};
